export default __webpack_public_path__ + "static/media/ALBARAKA.c0edcaae.png";